/**
  * This file handles the store search and map functionality for both the locations overview and single location pages.
  */

 (function ($) {
  'use strict';
  
  var ttLocations = {

    searchRadius: 20,
    markers: [],
    results: [],
    resultsCount: 0,
    panels: {
      count: 1,
      current: 1,
      maxTiles: {
        current: 6,
        sm: 3,
        md: 6,
        lg: 8
      }
    },
    settings: {
      map: {
        defaultLat: 39.8283,
        defaultLng: -98.5795,
        defaultZoom: 5,
        zoomControl: true,
        zoom: 5,
        icon: '/wp-content/uploads/map-pin@3x.png',
        alt: 'map icon'
      }
    },
    usStates: {
        'Alabama':'AL',
        'Alaska':'AK',
        'Arizona':'AZ',
        'Arkansas':'AR',
        'California':'CA',
        'Colorado':'CO',
        'Connecticut':'CT',
        'Delaware':'DE',
        'Florida':'FL',
        'Georgia':'GA',
        'Hawaii':'HI',
        'Idaho':'ID',
        'Illinois':'IL',
        'Indiana':'IN',
        'Iowa':'IA',
        'Kansas':'KS',
        'Kentucky':'KY',
        'Louisiana':'LA',
        'Maine':'ME',
        'Maryland':'MD',
        'Massachusetts':'MA',
        'Michigan':'MI',
        'Minnesota':'MN',
        'Mississippi':'MS',
        'Missouri':'MO',
        'Montana':'MT',
        'Nebraska':'NE',
        'Nevada':'NV',
        'New Hampshire':'NH',
        'New Jersey':'NJ',
        'New Mexico':'NM',
        'New York':'NY',
        'North Carolina':'NC',
        'North Dakota':'ND',
        'Ohio':'OH',
        'Oklahoma':'OK',
        'Oregon':'OR',
        'Pennsylvania':'PA',
        'Rhode Island':'RI',
        'South Carolina':'SC',
        'South Dakota':'SD',
        'Tennessee':'TN',
        'Texas':'TX',
        'Utah':'UT',
        'Vermont':'VT',
        'Virginia':'VA',
        'Washington':'WA',
        'West Virginia':'WV',
        'Wisconsin':'WI',
        'Wyoming':'WY'
    },

    /**
     * This function fires after the Google Maps API loads into the browser. This function is utilized on the
     * locations overview page (/locations/).
     *
     * @return null
     */
    initOverview: function() {
      
      $( "#search input[name='address']" ).focus(function() {
        var val = $(this).val();
        if (val == "Please enter a State, City, or Zip"){
          $(this).val("");
        }

      });

      $( "#search" ).submit(function(e) {
        e.preventDefault();        
        ttLocations.getUserLocationByAddress();        
      });

      $("#search-submit").on("click",function(e){
        e.preventDefault();
        ttLocations.getUserLocationByAddress();
      });

      $(".use-my-location").one("click",function(e){
        e.preventDefault();
        ttLocations.getUserLocation();
      });

      $("body").on("click", ".next-wrap a", function(e) {
        e.preventDefault();
        ttLocations.switchPanel($(this).attr('data-target-panel'));
      });

      $( window ).resize(function() {
        var prevCount = ttLocations.panels.maxTiles.current;
        ttLocations.setPaginationCount();
        if(prevCount != ttLocations.panels.maxTiles.current){
          ttLocations.buildPanels();
        }
      });
      
      
      ttLocations.getUserLocation();

    },

    /*** 
     * This function fires after the Google Maps API loads into the browser. This function is utilized on the
     * locations overview page (/locations/south-congress).
     * 
     * @return null
     */
    initSingle: function() {

    },

    /**
     * Add the loading spinner to the search button.
     *
     * @return null
     */
    showLoader: function() {
      $("#search-submit .btn-arrow").addClass("btn-loading");
      $("#ttMapLoader").show();
    },

    /**
     * Removes the loading spinner to the search button.
     *
     * @return null
     */
    hideLoader: function() {
      $("#search-submit .btn-arrow").removeClass("btn-loading");
      $("#ttMapLoader").hide();
    },

    /**
     * Removes the loading spinner to the search button.
     *
     * @return null
     */
    showNoResults: function() {
      var noResultsHTML = '<div id="no-results" aria-label="No results error messaging"><p>We are sorry, we could not find any restaurants using that search criteria.</p></div>';
      $(".locations-search-results .results").append(noResultsHTML);
    },

    /**
     * This function requests a users GPS coordinates from the browser.
     *
     * @return null
     */
    getUserLocation: function() {

      // Show Loader
      ttLocations.showLoader();

      // Reset Results
      ttLocations.resetResults();

      // Prompt for User Location
      navigator.geolocation.getCurrentPosition(function(position){
        var userLat = position.coords.latitude;
        var userLon = position.coords.longitude;

        if(jQuery.isNumeric(userLat) && jQuery.isNumeric(userLon)) {
          ttLocations.searchStores(userLat, userLon);
        }else{
          // Show Error Message
          ttLocations.showGPSError('We could not determine your location. Sorry!');
        }

      }, function(){
        // Show Error Message
          ttLocations.showGPSError('We could not determine your location. Sorry!');
      });

    },

    /**
     * This function process a manual location search. The location a user enters is turned into GPS coordinates, and then
     * passed off to the searchStores function for processing.
     *
     * @return null
     */
    getUserLocationByAddress: function(callback) {

      // Reset Results
      ttLocations.resetResults();

      var geocoder = new google.maps.Geocoder();
      var address = $("#search input[name='address']").val();

      // Check if user entered abbreviated state
      // If so, iterate through object to set address to full state
      if ((address.length === 2) && (Object.values(ttLocations.usStates).includes(address) > -1)) {
        var key = Object.keys(ttLocations.usStates).filter(function(key) {return ttLocations.usStates[key] === address})[0];
        address = key;
      }

      // Verify that the user has entered an address
      if(address == ''){
        // Show Error Message
        ttLocations.showError('Please enter a State, City, or Zip');
        return;
      }

      // Show Loader
      ttLocations.showLoader();
    
      geocoder.geocode({'address' : address}, function(results, status) {
        if(status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            var searchLat = results[0].geometry.location.lat();
            var searchLon = results[0].geometry.location.lng();
            var searchState = results[0].address_components[0].long_name;

            // NEED to check state abbreviation here against State Object
            // to return appropriate state
            if(jQuery.isNumeric(searchLat) && jQuery.isNumeric(searchLon)) {
              ttLocations.searchStores(searchLat, searchLon, searchState);
            }else{
              // Show Error Message
              ttLocations.showError('The address you entered could not be validated. Please try again.');
            }

          }else{
            // Show Error Message
            //ttLocations.showError('The address you entered could not be validated. Please try again.');
          }
        }else{
          // Show Error Message
          ttLocations.showError('Please enter a State, City, or Zip');
        }
      });
          
    },

    /**
     * This function will show a form level error.
     *
     * @return null
     */
    showError: function(msg) {

      // Hide Loader
      ttLocations.hideLoader();

      // Add New Error Message
      $("#search input[name='address']").val(msg);
      $("#search input[name='address']").addClass("error");
      $(".my-location").append('<p class="error">' + msg + '</p>');
    },

    /**
     * This function will show the get my location error.
     *
     * @return null
     */
    showGPSError: function(msg) {

      // Hide Loader
      ttLocations.hideLoader();

      // Add New Error Message
      $(".my-location").append('<p class="error">' + msg + '</p>');

    },

    /**
     * This function is used to determine which stores are within our defined search radius. The center point is the passed in
     * latitude and longitude. 
     *
     * @return null
     */
    searchStores: function(lat, lon, usState) {

      // Reset Saved Results
      ttLocations.results = [];
   
      $.getJSON( "/locations-json/", function( data ) {   
            
        $.each( data, function( key, val ) {
          if($.isNumeric(val.lat) && $.isNumeric(val.lon) && val.lat !== "0"){
            var distance = ttLocations.calcDistance(lat, lon, val.lat, val.lon);
            if(distance < ttLocations.searchRadius) {
              val.distance = distance;
              ttLocations.results.push(val);
            }
          }

          if(val.state === usState || val.state_abbr === usState) {
            ttLocations.results.push(val);
          }
        });   
        
        // Check that we have results
        if(ttLocations.results.length > 0) {

          // Sort the Results by distance nearest first
          ttLocations.results = ttLocations.results.sort(function(a,b){return a.distance - b.distance});

          // Process Search Results
          ttLocations.setPaginationCount();
          ttLocations.buildPanels();
          ttLocations.buildMap();

        }else{
          // Show No Results
          ttLocations.showNoResults();
        }

        // Hide Loader
        ttLocations.hideLoader();

      });
          
    },

    /**
     * This function builds and adds a pin/marker to the google map.
     *
     * @return null
     */
    buildMarker: function(store, isClickable, hasModal) {

      isClickable = isClickable || false;
      hasModal = hasModal || false;

      var marker = new google.maps.Marker({
        position: {lat: parseFloat(store.lat), lng: parseFloat(store.lon)},
        map: ttLocations.map,
        id: store.id,
        lat: parseFloat(store.lat),
        lng: parseFloat(store.lon),
        optimized: false,
        icon: {
          url: ttLocations.settings.map.icon,
          alt: ttLocations.settings.map.alt,
          optimized: true,
          size: new google.maps.Size(34, 36),
          scaledSize: new google.maps.Size(34, 36)
        }
      });

      if(isClickable){
        google.maps.event.addListener(marker, 'click', function () {
          var point = ttLocations.calculateTooltipCoords(marker.getPosition(), ttLocations.map);
          $('#marker-tooltip p').text(store.name);
          $('#marker-tooltip').css({
            'left': point.x,
            'top': point.y
          });
          $('#marker-tooltip').show();
          $('#marker-tooltip').click(function(){
            window.location.href = store.permalink;
          });
        });
      }

      ttLocations.markers.push(marker);

    },

    /**
     * Reset search results
     *
     * @return null
     */
    resetResults: function() {

      // Reset Existing Pins
      if (ttLocations.markers.length>0) { 
        for (var i = 0; i < ttLocations.markers.length; i++) {
          ttLocations.markers[i].setMap(null);
          $('#marker-tooltip').hide();
        }
        ttLocations.markers = [];
      }

      // Reset Results Panes
      $(".locations-search-results .results").html('');
      // @Michael trying to clear out error message so it doesn't continue to show when a user enters a correct location AFTER experiencing error.
      $("#search input[name='address']").removeClass("error");
      $("p.error").remove();
      
    },

    /**
     * This function adds the results markers to the google map and sets the viewport to match.
     *
     * @return null
     */
    buildMap: function() {

      // Loop through results, adding pins to the map
      $.each(ttLocations.results, function( key, store ) {
        ttLocations.buildMarker(store, true, true);
      });

      // Fit Map Bounds to Pins
      var bounds = new google.maps.LatLngBounds();
      if (ttLocations.markers.length>0) { 
        for (var i = 0; i < ttLocations.markers.length; i++) {
          bounds.extend(ttLocations.markers[i].getPosition());
        }    
        ttLocations.map.fitBounds(bounds);

        // Set Current Zoom
        ttLocations.settings.map.zoom = ttLocations.map.getZoom();
        if(ttLocations.settings.map.zoom > 20){
          // Set Minimum Zoom to 20
          ttLocations.map.setZoom(20);
          ttLocations.settings.map.zoom = 20;
        }
      }
    },

    calculateTooltipCoords: function(latLng) {
      var topRight = ttLocations.map.getProjection().fromLatLngToPoint(ttLocations.map.getBounds().getNorthEast());
      var bottomLeft = ttLocations.map.getProjection().fromLatLngToPoint(ttLocations.map.getBounds().getSouthWest());
      var scale = Math.pow(2, ttLocations.map.getZoom());
      var worldPoint = ttLocations.map.getProjection().fromLatLngToPoint(latLng);
      return new google.maps.Point(((worldPoint.x - bottomLeft.x) * scale + 17), (worldPoint.y - topRight.y) * scale - 36);
    },

    /**
     * Set the Current Tab Count in the Pagination Panels of Search Restuls
     *
     * @return null
     */
    setPaginationCount: function() {
      var browserWidth = $(window).width();
      if(browserWidth < 768){
        ttLocations.panels.maxTiles.current = ttLocations.panels.maxTiles.sm;
      }
      if(browserWidth >= 768 && browserWidth < 1200){
        ttLocations.panels.maxTiles.current = ttLocations.panels.maxTiles.md;
      }
      if(browserWidth >= 1200){
        ttLocations.panels.maxTiles.current = ttLocations.panels.maxTiles.lg;
      }
    },

    /**
     * Build the Pagination Panels for Search Results
     *
     * @return null
     */
    buildPanels: function() {

      // Reset Results Pane
      $(".locations-search-results").html('');

      var panelHTML = '<div class="results"><div class="pagination-panels"><div class="pagination-panel" data-panel="1"><div class="flex-row">';

      ttLocations.resultsCount = 0;
      ttLocations.panels.count = 1;

      console.log(ttLocations.results);

      $.each(ttLocations.results, function( key, store ) {
        
        ttLocations.resultsCount++;

        if(ttLocations.resultsCount != 1) {
          if((ttLocations.resultsCount - 1) % ttLocations.panels.maxTiles.current === 0){
            ttLocations.panels.count++;
            panelHTML += '</div>';
            panelHTML += '</div>';
            panelHTML += '<div class="pagination-panel" data-panel="' + ttLocations.panels.count + '">';
            panelHTML += '<div class="flex-row">';
          }
        }

        var mapLink = "";

        if(store['google_place_id'] && store['google_place_id'] !== null){
          mapLink = "https://maps.google.com/maps/search/?api=1&query=" + encodeURI(store['address'] + " " + store['city'] + " " + store['state'] + " " + store['zip']) + " " + "&query_place_id=" + store['google_place_id'];
        }else{
          mapLink = "https://maps.google.com/maps/search/?api=1&query=" + encodeURI(store['address'] + " " + store['city'] + " " + store['state'] + " " + store['zip']);
        }

        var storeHTML =  '<div class="tile-4-to-1 locations-item mapped-results" itemscope="" itemtype="http://schema.org/Restaurant">';
            storeHTML += '<div class="locations-content"><img src="'+store['image']['url']+'" itemprop="image" class="img-responsive " alt="-Image"/><div class="details-title">';
            storeHTML += '<a href="' + store.permalink + '">';
            storeHTML += '<span class="next-right"></span><h4 itemprop="name">' + store['name'] + '</h4></a></div>';
            storeHTML += '<div class="phone-address">';
            storeHTML += '    <a href="' + mapLink + '" itemprop="url" target="_blank" aria-label="'+ store['name'] +'-address">';
            storeHTML += '        <p class="address-icon"><span itemprop="address" itemscope="" itemtype="http://schema.org/PostalAddress">';
            storeHTML += '        <span itemprop="streetAddress">' + store['address'] + '</span>';
            storeHTML += '        <span itemprop="addressLocality">' + store['city'] + '</span>,';
            storeHTML += '        <span itemprop="addressRegion">' + store['state_abbr'] + '</span>';
            storeHTML += '        <span itemprop="postalCode">' + store['zip'] + '</span></span>';
            storeHTML += '        </p></a>';
            storeHTML += '</div>';
            storeHTML += '<div class="phone-address telephone">';
            storeHTML += '<a href="tel:' + store['phone'] + '" itemprop="telephone" class="phone-icon">' + store['phone'] + '</a>';
            storeHTML += '</div>';
            storeHTML += '    <img itemprop="image" itemscope style="display: none;" src="/wp-content/uploads/Torchys-Tacos-Careers-Banner.jpg" alt="location image"/>';
            storeHTML += '<span style="display: none;" itemprop="servesCuisine">Tacos</span>';
            storeHTML += '<span style="display: none;" itemprop="priceRange">$</span>';
            storeHTML += '</div>';
            storeHTML += '<div class="overlay-btn">';
            storeHTML += '    <a href="' + mapLink + '" itemprop="url" target="_blank" class="orange-btn"><span class="sm-btn-txt">map it</span><span class="sm-btn-arrow"></span></a>';
            storeHTML += '</div>';
            storeHTML += '</div>';

        panelHTML += storeHTML;

      });
      panelHTML += '</div></div></div>';

      if(ttLocations.resultsCount > ttLocations.panels.maxTiles.current) {
        
        var paginationControlsHTML  = '<div class="next-item flex-row">';
            paginationControlsHTML += '    <div class="next-wrap">';
            paginationControlsHTML += '        <a href="#" class="next-left" itemprop="url" data-target-panel="' + ttLocations.panels.count + '"></a>';
            paginationControlsHTML += '             <span class="opacity-txt">results 1-' + ttLocations.panels.maxTiles.current + ' of ' + ttLocations.resultsCount + '</span>';
            paginationControlsHTML += '         <a href="#" class="next-right" itemprop="url" data-target-panel="2"></a>';
            paginationControlsHTML += '    </div>';
            paginationControlsHTML += ' </div>';

        panelHTML += paginationControlsHTML;

      }

      panelHTML += '</div>';

      $(".locations-search-results").append(panelHTML);

    },

    /**
     * When the search results are paginated, this function is used to change which pagination panel is active.
     *
     * @return null
     */
    switchPanel: function(panelIndex) {

      // Save New Current Panel Index
      ttLocations.panels.current = panelIndex;

      // Hide All Panels
      $('.pagination-panel').hide();

      // Show New Current Panel
      $('.pagination-panel[data-panel="' + ttLocations.panels.current + '"]').show();

      // Update Pagination Text
      var showingStart = ((ttLocations.panels.maxTiles.current * ttLocations.panels.current) - ttLocations.panels.maxTiles.current + 1);
      var showingEnd = (ttLocations.panels.maxTiles.current * ttLocations.panels.current);
      if(showingEnd > ttLocations.resultsCount) {
        showingEnd = ttLocations.resultsCount;
      }
      if(showingStart == showingEnd){
        $(".opacity-txt").text('results ' + showingStart + ' of ' + ttLocations.resultsCount);
      }else{
        $(".opacity-txt").text('results ' + showingStart + '-' + showingEnd + ' of ' + ttLocations.resultsCount);
      }

      // Update Previous Panel Index
      var prevPanel = parseInt(ttLocations.panels.current) - 1;
      if(prevPanel < 1){
        prevPanel = ttLocations.panels.count;
      }
      $(".next-left").attr('data-target-panel',prevPanel);

      // Update Next Panel Index
      var nextPanel = parseInt(ttLocations.panels.current) + 1;
      if(nextPanel > ttLocations.panels.count){
        nextPanel = 1;
      }
      $(".next-right").attr('data-target-panel',nextPanel);

    },

    /**
     * This function configures the Google Maps options.
     *
     * @return null
     */
    configureMapOptions: function() {

      // Set Map Options
      ttLocations.mapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        mapTypeControl: false,        
        center: {lat: ttLocations.settings.map.defaultLat, lng: ttLocations.settings.map.defaultLng},
        zoom: ttLocations.settings.map.defaultZoom,
        gestureHandling: "cooperative",
        //gestureHandling: "greedy",
        minZoom: 4,
        disableDoubleClickZoom: true,
        zoomControl: true,
        clickableIcons: false,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ]
      };

    },

    /**
     * This function fires on the single locations pages. It fires as a callback to the Google Maps API loading in. It is used to initialize the Google Map 
     * and any and all location dependent elements.
     * 
     * @return null
     */
    mapInitSingle: function() {

      // Configure Map Options
      ttLocations.configureMapOptions();

      // Initialize map
      ttLocations.map = new google.maps.Map(document.getElementById("ttMap"), ttLocations.mapOptions);

      // Build Store Object
      var store = [];
          store.lat  = parseFloat($("#ttMap").data('lat'));
          store.lon = parseFloat($("#ttMap").data('lon'));
          store.name = $("#ttMap").data('name');
          store.id = parseInt($("#ttMap").data('id'));

      // Add Marker
      ttLocations.buildMarker(store);

      // Center and Zoom Map
      ttLocations.map.setCenter({lat: store.lat, lng: store.lon});
      ttLocations.map.setZoom(14);

    },

    /**
     * This function fires on the locations overview page. It fires as a callback to the Google Maps API loading in. It is used to initialize the Google Map 
     * and any and all location dependent elements.
     *
     * @return null
     */
    mapsInitOverview: function() {

      // Enable Address Search Button
      $('.locations-search').css('visibility', 'visible');  

      // Enable 'Use My Location' Button
      if ("geolocation" in navigator) {
        $('.my-location').css('visibility', 'visible');  
      }

      // Configure Map Options
      ttLocations.configureMapOptions();

      // initialize map
      ttLocations.map = new google.maps.Map(document.getElementById("ttMap"), ttLocations.mapOptions);

    },

    /**
     * This function converts numeric degrees to radians
     *
     * @return radians
     */
    deg2rad: function(deg) {
      return deg * (Math.PI/180);
    },

    /**
     * This function takes two sets of GPS coordinates, and calculates the distance between them. 
     *
     * @return dist
     */
    calcDistance: function(lat1, lon1, lat2, lon2, unit) {
      var R = 6371; // Radius of the earth in km
      var dLat = ttLocations.deg2rad(lat2-lat1);  // deg2rad below
      var dLon = ttLocations.deg2rad(lon2-lon1); 
      var a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(ttLocations.deg2rad(lat1)) * Math.cos(ttLocations.deg2rad(lat2)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2)
        ; 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c; // Distance in km
      return d;
    },

  }

  // Make ttLocations available globally
  window.ttLocations = ttLocations;

  // Initialize functionality on the locations overview page
  if($('body').hasClass('page-template-template-locations-overview')){
    ttLocations.initOverview();
  }

  // Initialize functionality on a single location page
  if($('body').hasClass('locations-template-content-single-locations')){
    ttLocations.initSingle();
  }

} (jQuery));